import React from 'react';

const InfoBlock = ({ label, value }) => {
    if (!value) return null;
    return (
        <div className="info-block">
            <div className="info-label">{label}</div>
            <div className="info-value">{value}</div>
        </div>
    );
};

export default InfoBlock;